(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/all-admin-checkbox.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/all-admin-checkbox.js');
'use strict';

const Icon = svs.ui.ReactIcon;
const IconButton = svs.ui.ReactIconButton;
const Checkbox = svs.ui.reactForm.Checkbox;
const {
  showAllAdminInformationDialog,
  showTechnicalError
} = svs.arena.pages.teams.dialogs;
const {
  putAdminWagerSyndicateAsync
} = svs.arena.service.teamsService;
const AllAdminCheckbox = _ref => {
  let {
    isAdminManagedWagers,
    teamId
  } = _ref;
  const [isAdminWager, setIsAdminWager] = React.useState(isAdminManagedWagers);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = React.useState(false);
  const handleClick = async e => {
    e.stopPropagation();
    setIsCheckboxDisabled(true);
    const response = await putAdminWagerSyndicateAsync(teamId, !isAdminWager);
    if (response.error) {
      showTechnicalError();
    } else {
      setIsAdminWager(!isAdminWager);
      const track = {
        category: 'spela-tillsammans',
        action: 'place_bet_all',
        opt_label: !isAdminWager ? 'yes' : 'no'
      };
      svs.components.analytics.trackEvent(track);
    }
    setIsCheckboxDisabled(false);
  };
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-between padding-bottom"
  }, React.createElement(Checkbox, {
    checked: !isAdminWager,
    className: "margin-top-1",
    disabled: isCheckboxDisabled,
    onChange: handleClick
  }, "Alla medlemmar kan l\xE4gga spel"), React.createElement(IconButton, {
    className: "align-self-center",
    onClick: e => showAllAdminInformationDialog(e.target),
    size: 300
  }, React.createElement(Icon, {
    icon: "information",
    size: "300"
  })));
};
svs.arena.pages.teams.components.AllAdminCheckbox = AllAdminCheckbox;

 })(window);